export default __webpack_public_path__ + "static/media/document-content-icon.98af8797.svg";